<template>
  <div class="about">
    <h1>{{ $t('views.about.title', 'About') }}</h1>
    <p class="description">
      {{ $t('views.about.descriptionTitle', 'Wemaik is…') }}
    </p>
    <blockquote class="quote">
      {{ $t('views.about.description', defaultDescription) }}
    </blockquote>
    <p>
      <a href="mailto:alainr@wemaik.com">
        Alain RAIS
      </a>,
      <a href="mailto:fredericd@wemaik.com">
        Frédéric DOEZY
      </a>
    </p>
    <AppMetadata
      class="product"
      :app="product" />
    <br>
    <v-divider />
    <AppMetadata
      v-for="(app, appIndex) in apps"
      :key="'App_' + appIndex"
      :app="app"
      :style="{ color: app.meta.theme && app.meta.theme.palette && app.meta.theme.palette.primary && app.meta.theme.palette.primary.main }" />
    <br>
    <v-divider />
    <AppMetadata
      v-for="(lib, libIndex) in libs"
      :key="'Lib_' + libIndex"
      :app="lib" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AppMetadata from '../components/App/AppMetadata'
import { APP_ROUTES } from '../constants/routing'
import { appRoute } from '../helpers/routing'

export default {
  components: {
    AppMetadata
  },
  data () {
    return {
      product: {
        title: process.env.VUE_APP_PRODUCT_TITLE,
        meta: {
          version: process.env.VUE_APP_PRODUCT_VERSION,
          buildDate: process.env.VUE_APP_BUILD_DATE
        }
      },
      portal: {
        title: process.env.VUE_APP_TITLE,
        meta: {
          version: process.env.VUE_APP_VERSION,
          buildDate: process.env.VUE_APP_BUILD_DATE,
          theme: {
            color: '#007bff'
          }
        }
      },
      defaultDescription: 'Wemaik 2.x is a complete rewrite, with a lot of new awesome features. You will be to '
              + 'select features like routing, Vuex or Typescript, then add and upgrade building blocks called '
              + '"vue-cli plugins". But having so much more options also means the tool is now more complex and harder '
              + 'to start using. That\'s why we thought having a full-blown GUI would help discover the new features, '
              + 'search and install vue-cli plugins and unlock more possibilities overall while not being limited by a '
              + 'terminal interface. To sum up, vue-cli will not only allow you to bootstrap a new project easily, but '
              + 'it will also remain useful for ongoing work afterwards!'
    }
  },
  computed: {
    ...mapGetters([
      'appRoute'
    ]),
    currentRoute () {
      return appRoute(this.$route)
    },
    apps () {
      return (this.appRoute.isRoot ? [
        this.portal,
        ...APP_ROUTES
      ] : [
        this.portal,
        this.appRoute
      ]).filter(app => app && app.meta && app.meta.title && app.meta.version)
    },
    libs () {
      return [
        {
          meta: {
            title: 'Schema-view',
            version: window.schemaView
          }
        },
        {
          meta: {
            title: 'Server-model',
            version: window.serverModel
          }
        },
        {
          meta: {
            title: 'We-com',
            version: window.weCom
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .about {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 840px;
    padding: 42px;
    height: 100%;
    overflow: auto;

    h1 {
      font-size: 42px;
    }

    .quote {
      border-left: 4px solid rgba(66,185,131,.3);
      color: #55789b;
      margin-left: 0;
      padding-left: 16px;
    }

    .actions {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 42px;
    }

    blockquote {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 40px;
      margin-inline-end: 40px;
    }
  }
</style>

<style lang="scss">
  .product {
    font-size: 20px;
    h3 {
      color: black;
    }
  }
</style>
